import { render } from "./Sprite.vue?vue&type=template&id=12c8b2fe"
import script from "./Sprite.vue?vue&type=script&lang=js"
export * from "./Sprite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__